import AgencySaleAddOrderScreen from 'features/Agency/screens/AgencySaleAddOrderScreen';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import CoinvestorDetailScreen from './screens/CoinvestorDetailScreen';
import CoinvestorListScreen from './screens/CoinvestorListScreen';
import AgencySaleDetailScreen from 'features/Agency/screens/AgencySaleDetailScreen';
import EditAgencyScreen from 'features/ManageDealer/screens/EditAgencyScreen';

function ManageCoinvestor(props) {
    const { isCoinvestorInfo } = props;
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route path="" element={<CoinvestorListScreen />} />
                    <Route
                        path={"/add"}
                        element={<EditAgencyScreen agencyRole="COINVESTOR" />}
                    />
                    <Route path="/:agencyId" element={<CoinvestorDetailScreen isCoinvestorInfo={isCoinvestorInfo} />} />
                    <Route
                        path={"/:agencyId/edit"}
                        element={<EditAgencyScreen agencyRole="COINVESTOR" isEditUserAgency={true} />}
                    />
                    <Route path="/:agencyId/sale/:saleId" element={<AgencySaleDetailScreen />} />
                    <Route path="/:agencyId/:saleId" element={<AgencySaleDetailScreen />} />
                    <Route path="/coinvestor-info/:agencyId" element={<CoinvestorDetailScreen />} />
                    <Route path="/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
                    <Route path="/:agencyId/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default ManageCoinvestor;
